import { createFileRoute } from '@tanstack/react-router'
import { HomeRouteComponent } from '@/components/home/HomeRouteComponent'

export const Route = createFileRoute('/')({
	head: () => ({
		meta: [
			{ title: 'A HIV, Hepatitis C (HEP C) Testing and Treatment Clinic in Fort Lauderdale, Fort Pierce, Rivera Beach - Wellview Care' },
			{
				name: 'description',
				content:
					'Wellview Care is a specialized clinic for STD testing and treatment, with a primary focus on HIV, Hepatitis C (HEP C), and preventive services such as PrEP. Call Now!',
			},
			{
				name: 'keywords',
				content: 'Wellview Care, STD testing service, STD clinic, HIV testing center',
			},
		],
	}),
	component: HomeRouteComponent,
})
